import React from 'react';
import { Rect } from 'react-native-svg';

import { IconBase, IconProps } from './IconBase';

export const IconGrid: React.FunctionComponent<IconProps> = ({ ...props }) => (
  <IconBase {...props}>
    <Rect x="3" y="3" width="8" height="8" rx="1.5" fill="currentColor" />
    <Rect x="13" y="3" width="8" height="8" rx="1.5" fill="currentColor" />
    <Rect x="3" y="13" width="8" height="8" rx="1.5" fill="currentColor" />
    <Rect x="13" y="13" width="8" height="8" rx="1.5" fill="currentColor" />
  </IconBase>
);
